<div class="row" [formGroup]="form" >
    <div class="col-md-6">
        <label class="form-labels mt-4">Número de Celular</label>
        <div class="input-group">
            <input type="tel" class="form-control" formControlName="celPhone" [brmasker]="{mask: '(000) 000-0000', type:'num'}" maxlength="14">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Otro número</label>
        <div class="input-group">
            <input type="tel" class="form-control" formControlName="homePhone" [brmasker]="{mask: '(000) 000-0000', type:'num'}" maxlength="14">
        </div>
    </div>

    <div class="col-md-12 mt-4">
        <h6>Dirección Fisica</h6>
    </div>

    <div class="col-md-6">
        <label class="form-labels mt-4">Dirección linea 1</label>
        <div class="input-group">
            <input type="text" class="form-control" formControlName="physicalAddress1">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Dirección linea 2</label>
        <div class="input-group">
            <input type="text" class="form-control" formControlName="physicalAddress2">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Ciudad</label>
        <div class="input-group">
            <input type="text" class="form-control" formControlName="physicalCity">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Estado</label>
        <div class="input-group">
            <input type="text" autocomplete="off" class="form-control" formControlName="physicalState" maxlength="2" (change)="updatePhysicalState()">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Zip Code</label>
        <div class="input-group">
            <input type="text" class="form-control" formControlName="physicalZip" [brmasker]="{mask: '00000-0000', type:'num'}">
        </div>
    </div>
    <div class="col-md-12">
        <label class="form-labels mt-4">¿La dirección postal es igual que la fisica?</label><br/>
        <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" value="si" name="select{{uniqueIden}}" id="sameAddressSi{{uniqueIden}}" (change)="sameAddress($event)">
            <label class="form-check-label">Si</label>
        </div>
        <div class="form-check form-check-inline">
            <input class="form-check-input" name="select{{uniqueIden}}" type="radio" value="no" #sameAddressNo{{uniqueIden}} id="sameAddressNo{{uniqueIden}}" (change)="sameAddress($event)">
            <label class="form-check-label">No</label>
        </div>
    </div>

    <div class="row" *ngIf="showPostalAddress"> 
        <div class="col-md-12 mt-4">
            <h6>Dirección Postal</h6>
        </div>
        <div class="col-md-6">
            <label class="form-labels mt-4">Dirección linea 1</label>
            <div class="input-group">
                <input type="text" class="form-control" formControlName="postalAddress1">
            </div>
        </div>
        <div class="col-md-6">
            <label class="form-labels mt-4">Dirección linea 2</label>
            <div class="input-group">
                <input type="text" class="form-control" formControlName="postalAddress2">
            </div>
        </div>
        <div class="col-md-6">
            <label class="form-labels mt-4">Ciudad</label>
            <div class="input-group">
                <input type="text" class="form-control" formControlName="postalCity">
            </div>
        </div>
        <div class="col-md-6">
            <label class="form-labels mt-4">Estado</label>
            <div class="input-group">
                <input type="text" class="form-control" formControlName="postalState" maxlength="2" (change)="updatePostalState()">
            </div>
        </div>
        <div class="col-md-6">
            <label class="form-labels mt-4">Zip Code</label>
            <div class="input-group">
                <input type="text" class="form-control" formControlName="postalZip" >
            </div>
        </div>
    </div>
</div>